/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import InteractionsClass from './Interactions';
import Amplify, { ConsoleLogger as Logger } from '@aws-amplify/core';
var logger = new Logger('Interactions');
var _instance = null;
if (!_instance) {
    logger.debug('Create Interactions Instance');
    _instance = new InteractionsClass(null);
}
var Interactions = _instance;
Amplify.register(Interactions);
export default Interactions;
export * from './Providers/AWSLexProvider';
export { InteractionsClass };
//# sourceMappingURL=index.js.map